import React from "react";
import { isLoading, Loading } from "../../Loading";
import { withDefault } from "../../utils/withDefault";

interface IsLoadedProps<T> {
  value: T | Loading;
  placeholder?: JSX.Element | string;
  comment?: string;
  children: (loadable: T) => JSX.Element;
}

export function IsLoaded<T>({ value, placeholder, children }: IsLoadedProps<T>) {
  return isLoading(value) ? <>{withDefault(placeholder, null)}</> : children(value);
}
